import React from 'react';
import PropTypes from 'prop-types';

import Config from '@/config';

const EmbedCode = ({ website_quoter }) => {
  return (
    <div>
      <p style={{ fontFamily: 'monospace', lineHeight: '1.8em', fontSize: '12px' }}>
        {`<link href='${Config.WQ_URL}@css/reset.css' rel='stylesheet' type='text/css'>`}
        <br />
        {"<script type='text/javascript'>"}
        <br />
        <span
          style={{ marginLeft: '20px' }}
        >{`window.IXN_QUOTER_CONFIG = { id: '${website_quoter.guid}' };`}</span>
        <br />
        {'</script>'}
        <br />
        {"<div id='ixn-website-quoter'></div>"}
        <br />
        {`<script type='text/javascript' src='${Config.WQ_URL}js/website_quoter.widget.js'></script>`}
      </p>
    </div>
  );
};

EmbedCode.propTypes = {
  website_quoter: PropTypes.object
};

export default EmbedCode;
